module.exports = __webpack_public_path__ + "static/media/cat-art-fashion-design.fad4ac85.jpg";